import { Phone, PhoneOff } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { useUserStatus } from "components/UserStatus/UserStatusContext";
import { Button } from "components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";
import { USER_STATUSES } from "constants/Constants";
import { cn } from "lib/utils";

const STATUS_COLORS = {
  [USER_STATUSES.ONLINE.key]: "tw:text-success",
  [USER_STATUSES.OFFLINE.key]: "tw:text-destructive",
  [USER_STATUSES.DISCONNECTED.key]: "tw:text-muted-foreground",
  [USER_STATUSES.DISABLED.key]: "tw:text-muted-foreground",
  [USER_STATUSES.ON_CALL.key]: "tw:text-primary",
};

const STATUS_BG_COLORS = {
  [USER_STATUSES.ONLINE.key]: "tw:bg-success",
  [USER_STATUSES.OFFLINE.key]: "tw:bg-destructive",
  [USER_STATUSES.DISCONNECTED.key]: "tw:bg-muted-foreground",
  [USER_STATUSES.DISABLED.key]: "tw:bg-muted-foreground",
  [USER_STATUSES.ON_CALL.key]: "tw:bg-primary",
};

// Only these two are user-selectable; the rest are set by the call system.
const SELECTABLE_STATUSES = [USER_STATUSES.ONLINE, USER_STATUSES.OFFLINE];

function UserStatus() {
  const { status, isDisabled, updateStatus } = useUserStatus();

  const StatusIcon = isDisabled ? PhoneOff : Phone;
  const selectedStatus =
    status === USER_STATUSES.ONLINE.key
      ? USER_STATUSES.ONLINE.key
      : USER_STATUSES.OFFLINE.key;

  return (
    <Authorized permissions={[ACL_RELATIONSHIPS.callAgentStatus.read]}>
      <DropdownMenu>
        <DropdownMenuTrigger
          disabled={isDisabled}
          aria-label="Change availability status"
          render={
            <Button variant="outline" size="icon" className="tw:rounded-full">
              <StatusIcon className={STATUS_COLORS[status]} />
            </Button>
          }
        />

        <DropdownMenuContent className="tw:w-36">
          <DropdownMenuRadioGroup
            value={selectedStatus}
            onValueChange={updateStatus}
          >
            {SELECTABLE_STATUSES.map(({ key, label }) => (
              <DropdownMenuRadioItem
                key={key}
                value={key}
                className="tw:cursor-pointer"
              >
                <span
                  aria-hidden="true"
                  className={cn(
                    "tw:size-2 tw:rounded-full tw:bg-current",
                    STATUS_BG_COLORS[key]
                  )}
                />
                {label}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </Authorized>
  );
}

export default UserStatus;
